    export interface IResourceModel {
        type: ResourceType;
        code: string;
        data: string;
    }

    export enum ResourceType {
        Control = "S",
        Image = "I",
        Audio = "A",
        //123 drink...
    }

